import React from 'react';
import './Specialized.css';
import foodImg from '../imgs/foodcontainer.webp';
import jarImg from '../imgs/jar.webp';
import beverageImg from '../imgs/Beveragebottle.webp';
import bulbImg from '../imgs/bulbcover.webp';


const Specialized = () => {
  const solutions = [
    {
      title: "Thin-Wall Plastic Products",
      items: ["Food Container, Syringe, Mobile Case etc"],
      img: foodImg
    },
    {
      title: "PET Preform",
      items: ["Preform For PET Bottle, Jar, 5 Gallon Water Bottle etc"],
      img: jarImg
    },
    {
      title: "Extrusion Blowing Bottle",
      items: ["Beverage Bottle, Jerry Can, Detergent Bottle etc"],
      img: beverageImg
    },
    {
      title: "LED Bulb Cover",
      items: ["Cosmetic, Pills Bottle etc"],
      img: bulbImg
    }
  ];

  return (
    <div className="solutions-container">
      <h2 className="solutions-heading">Specialized Solutions</h2>
      <div className="solutions-grid">
        {solutions.map((solution, index) => (
          <div key={index} className="solution-card" data-aos="fade-down">
            <img src={solution.img} alt={solution.title} className="card-image" />
            <h3 className="card-title">{solution.title}</h3>
            <ul className="card-items">
              {solution.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Specialized;
